import { InfoCircleOutlined, WarningFilled, WarningOutlined } from '@easyv/react-icons';
import classNames from 'classnames';
import { formatNumber, isNil, parseFileSize } from '@/utils';
import { AssetInfoPanel, AssetInfoPanelData } from './AssetInfoPanel';
import { ModelWarningPanel } from './ModelWarningPanel';
import { ModelInfoType } from './type';
import { AssetItem } from '@/type';
import { isEmptyObj } from '@easytwin/runtime';
import { Tooltip } from '@easyv/react-components';
import React from 'react';

export interface AssetDetailIconProps {
  className: string;
  data: AssetItem;
}

export function AssetDetailIcon(props: AssetDetailIconProps) {
  const { data, className } = props;
  const { type } = data;

  const { content } = data;
  if (isNil(content) || isNil((content as any).url)) {
    return (
      <Tooltip position='top' content={<AssetInfoPanel data={[]} />} className='asset-model-info'>
        <InfoCircleOutlined
          size={18}
          type='primary'
          className={classNames('cursor-pointer hover:text-white', className)}
        />
      </Tooltip>
    );
  }

  switch (type) {
    case 'folder': {
      return null;
    }
    case 'image': {
      const { content } = data as AssetItem<'image'>;
      const { info } = content;
      const textMap: AssetInfoPanelData[] = [
        {
          label: '文件大小',
          data: parseFileSize(info.fileSize),
        },
        {
          label: '图片尺寸',
          data: `${info.size.x} X ${info.size.y}`,
        },
        {
          label: '格式',
          data: info.ext,
        },
      ];
      return (
        <Tooltip
          position='top'
          content={<AssetInfoPanel data={textMap} />}
          className='asset-model-info'
        >
          <div className='w-5 h-5 rounded-[10px] p-[2px] bg-[#00000040] flex text-center justify-center text-FFFFFFC0'>
            <InfoCircleOutlined
              size={16}
              type='primary'
              className={classNames('cursor-pointer hover:text-white', className)}
            />
          </div>
        </Tooltip>
      );
    }
    case 'model': {
      const { content } = data as AssetItem<'model'>;
      const { info } = content;
      let modelInfoType: ModelInfoType = 'info';
      if (isNil(info)) {
        return null;
      }
      if (info.warnings.length > 0) {
        modelInfoType = 'warning';
      }

      switch (modelInfoType) {
        case 'warning':
          return (
            <Tooltip
              position='top'
              className='asset-model-info'
              content={<ModelWarningPanel assetItem={data as AssetItem<'model'>} data={info} />}
            >
              <div className='w-5 h-5 rounded-[10px] p-[2px] bg-[#00000040] flex text-center justify-center text-FFFFFFC0'>
                <WarningOutlined
                  size={16}
                  type='primary'
                  className={classNames(
                    'cursor-pointer hover:text-amber-200 text-amber-500',
                    className,
                  )}
                />
              </div>
            </Tooltip>
          );
        case 'info':
        default: {
          const textMap: AssetInfoPanelData[] = [
            {
              label: '文件大小',
              data: parseFileSize(info.fileSize),
            },
            {
              label: '模型尺寸',
              data: `${info?.size?.x?.toFixed(2)} m X ${info?.size?.y?.toFixed(
                2,
              )} m X ${info?.size?.z?.toFixed(2)} m`,
            },
            {
              label: '面数',
              data: formatNumber(info.triangleCount || 0),
            },
            {
              label: '材质数量',
              data: formatNumber(info.materialCount || 0),
            },
          ];

          return (
            <Tooltip
              position='top'
              content={<AssetInfoPanel data={textMap} />}
              className='asset-model-info'
            >
              <InfoCircleOutlined
                size={18}
                type='primary'
                className={classNames('cursor-pointer hover:text-white', className)}
              />
            </Tooltip>
          );
        }
      }
    }

    default:
      return null;
  }
}
